<template>
	<div>
		<header>
			<h1 class="alpha heavy">Create new case</h1>
		</header>
		<div>
			<TheClientForm/>
		</div>
	</div>
</template>
<script>
import TheClientForm from "./forms/TheClientForm.vue";

export default {
	components: {
		TheClientForm,
	},
};
</script>
